<template>
    <div v-if="activeModelName" class="model-name-display">
        {{ activeModelName }}
    </div>
</template>
<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState(["activeModelName"]),
    },
}
</script>
<style lang="scss">
.model-name-display {
    font-size: 20px;
    font-weight: bold;
    color: #409eff;
    padding: 6px 16px;
    border-radius: 5px;
    white-space: nowrap;
}
</style>
